import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Checkbox from '../../common/Checkbox';
import { ELECTRONIC_DELIVERY_NOTICE } from '../../../constants';

/**
 * Delete whole component once TermsAndConditions is fully migrated and
 * useTermsAndConditions || QuoteSiteEBT194633CheckboxesText be removed.
 * Don't forget to remove also "legacy" CSS classes.
 * @returns
 */
const TermsAndConditionsLegacy = ({
  agreePaymentAndRenewalCheck = false,
  agreePaymentAndRenewalError = false,
  agreeTermsAndConditionCheck = false,
  agreeTermsAndConditionError = false,
  consentElectronicDeliveryCheck = false,
  containerRef = null,
  handleAgreeTermsClick = () => {},
  handleConsentDeliveryClick = () => {},
  handleTermsAndConditionsModalOpen = () => {},
  handleUnderstandConditionClick = () => {},
  handleUnderstandConditionModalOpen = () => {},
  shouldRenderElectronicConsent = false,
}) => {
  const { t } = useTranslation('enrollment');

  const renderElectronicConsent = () => {
    if (shouldRenderElectronicConsent) {
      return (
        <Checkbox
          checked={consentElectronicDeliveryCheck}
          dark
          id="electronicDeliveryNotice"
          onClick={handleConsentDeliveryClick}
        >
          <Trans
            components={{
              a: (
                // eslint-disable-next-line max-len
                // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                <a
                  className="Terms-and-condition-child-modal-clickable"
                  href={ELECTRONIC_DELIVERY_NOTICE}
                  rel="noopener noreferrer"
                  target="_blank"
                />
              ),
            }}
            i18nKey="termsAndConditionsLegacy.electronicDelivery"
            ns="enrollment"
            t={t}
          />
        </Checkbox>
      );
    }

    return null;
  };

  return (
    <div
      ref={containerRef}
      className={'Your-info-agreements-container-legacy '
          + 'Terms-condition-checkbox-container-legacy'}
      tabIndex={-1}
    >
      <Checkbox
        anounceError={false}
        checked={agreeTermsAndConditionCheck}
        className="Terms-condition-checkbox"
        containerClassName="Terms-and-condition-checkbox-container"
        dark
        error={agreeTermsAndConditionError}
        errorMessage="Required. Please confirm statement to proceed."
        id="iAgreeTerms"
        keepSpaceError
        onClick={handleAgreeTermsClick}
      >
        <Trans
          components={{
            button: (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label
              <button
                aria-controls="termsAndConditionmodalContainer"
                aria-haspopup="dialog"
                className="Terms-and-condition-child-modal-clickable"
                onClick={handleTermsAndConditionsModalOpen}
                type="button"
              />
            ),
          }}
          i18nKey="termsAndConditionsLegacy.termsAndConditions"
          ns="enrollment"
          t={t}
        />
      </Checkbox>

      <Checkbox
        anounceError={false}
        checked={agreePaymentAndRenewalCheck}
        className="Terms-condition-checkbox"
        containerClassName="Terms-and-condition-checkbox-container"
        dark
        error={agreePaymentAndRenewalError}
        errorMessage="Required. Please confirm statement to proceed."
        id="iUnderstandCondition"
        keepSpaceError
        onClick={handleUnderstandConditionClick}
      >
        <Trans
          components={{
            button: (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label
              <button
                aria-controls="termsAndConditionmodalContainer"
                aria-haspopup="dialog"
                className="Terms-and-condition-child-modal-clickable"
                onClick={handleUnderstandConditionModalOpen}
                type="button"
              />
            ),
          }}
          i18nKey="termsAndConditionsLegacy.preExistingConditions"
          ns="enrollment"
          t={t}
        />
      </Checkbox>

      {renderElectronicConsent()}
    </div>
  );
};

export { TermsAndConditionsLegacy };
